<!-- 组件说明 -->
<template>
  <div>
    <div class="date-select">
      <!-- <div class="deadline">数据截止2020年07月01日 12:00</div> -->
      <div class="deadline">数据截止{{ deadLine }}</div>
      <div class="seleted-ratio">
        <span
          :class="['slider', userCode.type === 'm' ? 'slider-selecter' : '']"
          @click="userCode.type = 'm'"
          >当月</span
        >
        <span
          :class="['slider', userCode.type === 'y' ? 'slider-selecter' : '']"
          @click="userCode.type = 'y'"
          >当年</span
        >
      </div>
    </div>
    <table class="table">
      <tr>
        <th v-for="item in allStatus" :key="item.status">{{ item.name }}</th>
      </tr>
      <tr>
        <td v-for="item in allStatus" :key="item.status">{{ item.num }}</td>
      </tr>
    </table>

    <div class="page-bottom"></div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["projectCode", "orgCode"],
  components: {},
  data() {
    return {
      name: ["认证数", "报备数", "到访数", "认购数", "签约数"],
      number: [],
      allStatus: [
        {
          name: "认证数",
          status: "certification",
          num: 0,
        },
        {
          name: "报备数",
          status: "report",
          num: 0,
        },
        {
          name: "到访数",
          status: "visit",
          num: 0,
        },
        {
          name: "认购数",
          status: "subscribe",
          num: 0,
        },
        {
          name: "签约数",
          status: "signing",
          num: 0,
        },
      ],
      userCode: {
        projectCode: this.projectCode,
        orgCode: this.orgCode,
        type: "m",
      },
    };
  },
  computed: {
    deadLine() {
      return moment().format("YYYY年MM月DD日 HH:mm");
    },
  },
  methods: {
    // 各个状态统计
    allStatusStatistical() {
      let date =
        this.userCode.type === "m"
          ? moment().format("YYYY-MM")
          : moment().format("YYYY");
      let params = Object.assign({}, this.userCode, { date });
      this.$api.allStatusStatistical(params).then((res) => {
        if (res.status && res.code === "0000" && res.body.length !== 0) {
          let body = res.body[0];
          this.allStatus.forEach((res) => {
            res.num = body[res.status] ? parseInt(body[res.status]) : 0;
          });
        } else {
          this.allStatus.forEach((res) => {
            res.num = 0;
          });
        }
      });
    },
  },
  created() {
    this.allStatusStatistical();
  },
  watch: {
    // 监听项目选择变化
    projectCode(val) {
      this.userCode.projectCode = val;
      this.userCode.orgCode = this.orgCode;
      this.allStatusStatistical();
    },
    "userCode.type"() {
      this.allStatusStatistical();
    },
  },
};
</script>

<style lang="scss" scoped>
.date-select {
  display: flex;
  justify-content: space-between;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 24px;
  font-weight: 400;

  .deadline {
    color: #0f4432;
    line-height: 56px;
  }
}
.seleted-ratio {
  width: 172px;
  height: 56px;
  background: #ffffff;
  border-radius: 12px;
  border: 2px solid #eeeeee;
  padding: 6px;
  .slider {
    width: 75px;
    height: 36px;
    border-radius: 12px;
    display: inline-block;
    text-align: center;
    line-height: 36px;
    font-size: 24px;
    color: #0d9869;
    font-family: PingFangSC-Regular, PingFang SC;
    &.slider-selecter {
      background: #0d9869;
      box-shadow: 0px 0px 4px 0px rgba(13, 152, 105, 0.4);
      color: #ffffff;
    }
  }
}
.table {
  width: 690px;
  height: 180px;
  border-radius: 12px;
  border: 2px solid #f1f1f1;
  text-align: center;
  margin: 34px 0 0;
  th {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  td {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0d9869;
  }
}
.page-bottom {
  height: 50px;
}
</style>
